import styled from 'styled-components'
import SelectableChip from '../atoms/SelectableChip';
import RemovableChip from '../atoms/RemovableChip';
import { logEvent } from '../../utils/eventLogger';

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`

const WordChipList = ({ hrId, drId, rates, selectedMeaning, addMeaning, onSelect, onRemove }) => {
  const handleSelect = (meaning, rank) => {
    // 의미 추가한 칩이면 토글 막기
    if (meaning === addMeaning) {
      onSelect(addMeaning, 99); // 무조건 선택 상태로 유지
      return;
    }

    // 추천 의미단어 칩은 토글 허용
    if (meaning === selectedMeaning) {
      onSelect(null, 0);

      // 로그 기록
      logEvent("labeling_submit", {
        hrId: hrId,
        drId: drId,
        labelMethod: "cancel",
        seqNo: rank // 취소 시에도 이전에 기록했던 그 rate를 보냄
      })

    } else {
      onSelect(meaning, rank);

      // 로그 기록
      logEvent("labeling_submit", {
        hrId: hrId,
        drId: drId,
        labelMethod: "recommended_select",
        seqNo: rank
      });
    }
  };
  
  return (
    <Wrapper>
      {rates.map((item, idx) => (
        <SelectableChip
          key={`rate-${idx}`}
          label={item.meaning}
          $isActive={item.meaning === selectedMeaning}
          onSelect={() => handleSelect(item.meaning, item.rank)}
          rate={item.rate}
        />
      ))}
      {addMeaning && (
        <RemovableChip
          label={addMeaning}
          $isActive={addMeaning === selectedMeaning}
          onSelect={() => handleSelect(addMeaning, 99)}
          onRemove={onRemove}
        />
      )}
    </Wrapper>
   

  )
}

export default WordChipList
